export interface CollectionProps {
    id: string;
    imageId: string;
    action: {
        link: string;
        text: string;
        type: string;
    };
    entityType: string;
    entityId: string;
    accessibility?: {
        altText: string;
        altTextCta: string;
    };
    screenName?: string;
    onViewItem?: (data: any) => void;
    index?: number;
    style: Style;
}

export interface GridHeader {
    title: string;
}

export enum WIDGET_TYPES {
    GRID_WIDGET = "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
}

export enum WIDGET_IDS {
    MERCH_CAROUSEL = "merch-banner",
}

export interface GridLayout {
    rows: string | number;
    columns: string | number;
    horizontalScrollEnabled: boolean;
    shouldSnap?: boolean;
    scrollBar?: {
        width?: number;
        height?: number;
        scrollThumbColor?: string;
        scrollTrackColor?: string;
        scrollStyling?: {
            padding?: {
                top?: number;
                bottom?: number;
            };
        };
    };
    itemSpacing: number;
    widgetPadding?: {
        top?: number;
        bottom?: number;
    };
    containerStyle?: {
        containerPadding: {
            left: number;
            top: number;
            right: number;
            bottom: number;
        };
    };
    autoScrollConfig?: {
        isScrollEnabled?: boolean;
        autoScrollDuration?: number;
        autoScrollResetDuration?: number;
    };
    dotScrollBar?: {
        activeColor?: string;
        inactiveColor?: string;
        activeSize?: number;
        inactiveMediumSize?: number;
        inactiveSmallSize?: number;
        dotSpacing?: number;
        windowSize?: number;
        showCount?: true;
        textColor?: string;
        scrollStyling?: {
            padding?: {
                top?: number;
                bottom?: number;
            };
        };
    };
}
export interface MerchCarouselProps {
    "@type"?: WIDGET_TYPES.GRID_WIDGET;
    layout: GridLayout;
    id: WIDGET_IDS.MERCH_CAROUSEL;
    screenName?: string;
    gridElements: {
        infoWithStyle: {
            info: CollectionProps[];
            style: Style;
        };
    };
    isCalloutExists?: boolean;
}
export interface Style {
    height?: Height;
    width?: Width;
}
export type Height = {
    reference?: string;
    type?: string;
    value?: number;
};
export type Width = {
    reference?: string;
    type?: string;
    value?: number;
};
export enum GridType {
    CAROUSEL = "carousel",
    GRID = "grid",
}

export interface ImageWrapperProps {
    height: number;
    width: number;
}

export interface MerchApiResponse {
    tid: string;
    sid: string;
    deviceId: string;
    requestId: string;
    apiTime: string;
    jid: string;
    success: {
        statusMessage: string;
        cards: {
            card: {
                "@type": string;
                header: {};
                layout: GridLayout;
                imageGridCards: {
                    info: {
                        id: string;
                        imageId: string;
                        action: {
                            type: string;
                        };
                        entityType: string;
                        accessibility: {
                            altText: string;
                            altTextCta: string;
                        };
                        entityId: string;
                        frequencyCapping: {};
                        externalMarketing: {};
                    }[];
                    style: {
                        width: {
                            type: string;
                            value: number;
                            reference: string;
                        };
                        height: {
                            type: string;
                            value: number;
                            reference: string;
                        };
                    };
                };
                id: string;
                gridElements: {
                    infoWithStyle: {
                        "@type": string;
                        info: CollectionProps[];
                        style: {
                            width: {
                                type: string;
                                value: number;
                                reference: string;
                            };
                            height: {
                                type: string;
                                value: number;
                                reference: string;
                            };
                        };
                    };
                };
            };
        }[];
        firstOffsetRequest: boolean;
        nextFetch: number;
    };
}
